    
import axios from 'axios';
import React, { useState, useEffect, use } from 'react';
import '../styles/global.css';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useLocation } from "react-router-dom";

//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com{pdfjs.version}/pdf.worker.min.js`;

function ViewPDF(state) {
  const location = useLocation();
  const navigate = useNavigate();

  const {registro} = location.state || {};
  
  // console.log(registro);
  // console.log(registro.pdcExtrato);
  // console.log(registro.lanDocumento);
  // console.log("../api/" + registro.pdcExtrato !== undefined ? registro.pdcExtrato : registro.lanDocumento);
  // console.log(registro.hasOwnProperty('pdcExtrato'));
  // console.log(registro.hasOwnProperty('lanDocumento'));
  // useEffect(() => {
  // if (isMobile) {
  //   alert("A visualização de documentos não é otimizada para dispositivos móveis. O documento será aberto em uma nova aba.");
  // } else {
  //   alert("A visualização de documentos é otimizada para desktop. Se estiver usando um dispositivo móvel, o documento será aberto em uma nova aba.");
  // }
  // }, []);
  const [pdfUrl, setPdfUrl] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [vURL, setVURL] = useState("");
  if (vURL === "" && registro.hasOwnProperty('pdcExtrato')) {
    setVURL("../api/" + registro.pdcExtrato);
    }
  else if (vURL === "" && registro.hasOwnProperty('lanDocumento')) {
    setVURL("../api/" + registro.lanDocumento);
    }
  else if (vURL === "" && registro.hasOwnProperty('docCaminho')) {
    setVURL("../api/" + registro.docCaminho);
    }
  else if (vURL === "" && registro.hasOwnProperty('ageAnexo')) {
    setVURL("../api/" + registro.ageAnexo);
    }
  else if (vURL === "" && registro.hasOwnProperty('mslRecibo')) {
    setVURL("../api/" + registro.mslRecibo);
    }
console.log(vURL);
  useEffect(() => {
    var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const urlArquivo = {
        urlArquivo: vURL
      }
    axios
    .post(
      process.env.REACT_APP_API_URL + 
      '/routes.php?metodo=obtemExtrato', urlArquivo, {
          headers: {
          "X-Access-Token": token,
          "Content-Type": "application/json; charset=UTF-8"
          }
      })
      .then(response => {
        // if(!response.ok) {
        //   throw new Error('Erro ao carregar o PDF: ' + response.statusText);
        // }
        return response.data;//.json();
      })
      .then(data => {
        if (data.success && data.data) {
            // Decodifica a string Base64 em um Blob binário
            const byteCharacters = atob(data.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // console.log(vURL);
            // console.log(vURL.split('.').pop());
            // Cria um Blob do tipo PDF
            // Cria um URL de objeto temporário para o Blob
            if (vURL.split('.').pop().toLowerCase() === 'pdf'){
              const blob = new Blob([byteArray], { type: 'application/pdf' });
              const url = URL.createObjectURL(blob);
              setPdfUrl(url);
            }
            else {
              const blob = new Blob([byteArray], { type: 'image/jpeg' });
              const url = URL.createObjectURL(blob);
              setPdfUrl(url);
            }
            
            
            //setPdfData(`data:application/pdf;base64,${data.data}`);
        } else {
            setError(data.message || 'Falha ao processar o PDF no servidor.');
        }
      })
      .catch(err => {
          setError(err.message);
      })
      .finally(() => {
          setIsLoading(false);
      });
  },[]);

  if (isLoading) {
    return <div><main>Carregando PDF...</main></div>;
  }

  if (error) {
    return <div><main>Erro: {error}</main></div>;
  }

  function handleVoltarCadastro() {
        //setModalOpen(false);
        //navigate(-1);
        if (registro.hasOwnProperty('mslRecibo')) {
          if(sessionStorage.reciboOrigem === "AreaDoAssociado") {
            window.history.back();
          }
          else if (sessionStorage.reciboOrigem === "Mensalidade") {
            navigate('/Mensalidade/' + registro.mslAno + '/' + registro.mslMes);
          }
          //return;
        } else {
          navigate(-1);
          //window.history.back();
        }
    }

  return (
    <div style={{ paddingBottom: '80px' }}>
      <main>
        <div style={{ padding: "20px" }} className="d-flex flex-row w100 text-align-left" >
          <div className='floatLeft w50'><h3>Visualização de Documento</h3></div>
          <div className='floatRight w50 text-align-right'>
            <button className="buttonModalPadrao" onClick={handleVoltarCadastro}>
                VOLTAR
            </button>
          </div>
        </div>
      {pdfUrl ? (
        <iframe
            src={pdfUrl} 
            toolbar="false"
            title="Visualizador de Documento"
            width="100%"
            height="100vh" 
            className='h100vh'
            style={{ border: 'none', print: 'none' }}
            // onLoad={(e) => {
            //   // Isso requer que o PDF seja do mesmo domínio (same-origin)
            //   try {
            //     const iframeWindow = e.target.contentWindow;
            //     // Tentar sobrescrever a função de impressão
            //     iframeWindow.print = () => {
            //       alert("Impressão desabilitada para este documento.");
            //     };
            //     // Ou adicionar um listener, o que é difícil de fazer funcionar de forma consistente
            //   } catch (error) {
            //     console.log("Não foi possível acessar o conteúdo do iframe devido à política de mesma origem.");
            //   }
            // }}
        />
        ) : (
            <div>Não foi possível gerar a URL do PDF.</div>
        )}
        { isMobile ? (window.open(pdfUrl, '_blank', 'noopener,noreferrer'), handleVoltarCadastro()) : null }

        </main>
    </div>
  );
}

export default ViewPDF;